<template>
  <div class="sale-order">
    <page-header title="销售订单" icon="el-icon-document"></page-header>

    <!-- 搜索栏 -->
    <el-card>
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="订单编号">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单编号"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="searchForm.customerName" placeholder="请输入客户名称"></el-input>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="待付款" value="UNPAID"></el-option>
              <el-option label="已付款" value="PAID"></el-option>
              <el-option label="已发货" value="SHIPPED"></el-option>
              <el-option label="已完成" value="COMPLETED"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 订单列表 -->
      <el-table :data="orderList" border style="width: 100%">
        <el-table-column prop="orderNo" label="订单编号" width="180"></el-table-column>
        <el-table-column prop="customerName" label="客户名称" width="120"></el-table-column>
        <el-table-column prop="phone" label="联系电话" width="120"></el-table-column>
        <el-table-column prop="totalAmount" label="订单金额" width="120">
          <template slot-scope="scope">
            ￥{{ scope.row.totalAmount }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" width="180"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="viewDetail(scope.row)">查看详情</el-button>
            <el-button 
              v-if="scope.row.status === 'UNPAID'"
              type="text" 
              @click="handlePay(scope.row)">
              确认付款
            </el-button>
            <el-button 
              v-if="scope.row.status === 'PAID'"
              type="text" 
              @click="handleShip(scope.row)">
              确认发货
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue'

export default {
  name: 'SaleOrder',
  components: {
    PageHeader
  },
  data() {
    return {
      searchForm: {
        orderNo: '',
        customerName: '',
        status: '',
        dateRange: []
      },
      orderList: [
        {
          orderNo: 'SO202403150001',
          customerName: '张三',
          phone: '13800138000',
          totalAmount: 1000,
          status: 'UNPAID',
          createTime: '2024-03-15 10:00:00'
        },
        {
          orderNo: 'SO202403150002',
          customerName: '李四',
          phone: '13800138001',
          totalAmount: 2000,
          status: 'PAID',
          createTime: '2024-03-15 11:00:00'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  methods: {
    getStatusType(status) {
      const statusMap = {
        'UNPAID': 'warning',
        'PAID': 'success',
        'SHIPPED': 'primary',
        'COMPLETED': 'info'
      }
      return statusMap[status]
    },
    getStatusText(status) {
      const statusMap = {
        'UNPAID': '待付款',
        'PAID': '已付款',
        'SHIPPED': '已发货',
        'COMPLETED': '已完成'
      }
      return statusMap[status]
    },
    handleSearch() {
      // TODO: 调用搜索API
      console.log('搜索条件：', this.searchForm)
    },
    resetSearch() {
      this.searchForm = {
        orderNo: '',
        customerName: '',
        status: '',
        dateRange: []
      }
    },
    viewDetail(row) {
      // TODO: 查看订单详情
      console.log('查看订单：', row)
    },
    handlePay(row) {
      this.$confirm('确认该订单已付款？', '提示', {
        type: 'warning'
      }).then(() => {
        // TODO: 调用确认付款API
        this.$message.success('操作成功')
      })
    },
    handleShip(row) {
      this.$confirm('确认发货？', '提示', {
        type: 'warning'
      }).then(() => {
        // TODO: 调用确认发货API
        this.$message.success('操作成功')
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      // TODO: 重新加载数据
    },
    handleCurrentChange(val) {
      this.page.current = val
      // TODO: 重新加载数据
    },
    handleCreate() {
      this.$router.push('/sale/create')
    }
  }
}
</script>

<style scoped>
.sale-order {
  padding: 20px;
}
.search-bar {
  margin-bottom: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style> 